<template>
  <div class="metric-chart">
    <svg viewBox="0 0 660 230" role="img" :aria-label="label">
      <g v-for="tick in [0,1,2,3]" :key="tick"><line x1="64" :y1="20 + tick * 55" x2="642" :y2="20 + tick * 55" class="chart-grid" /><text x="54" :y="24 + tick * 55" text-anchor="end" class="chart-axis">{{ compact(maximum - (maximum - minimum) * tick/3) }}</text></g>
      <line x1="64" :y1="position(0)" x2="642" :y2="position(0)" stroke="#cfd8e6" />
      <g v-for="(item, index) in items" :key="item.month" tabindex="0" role="button" :aria-label="`${month(item.month)}: ${formatted(item[metric])}`" @focus="active = index" @mouseenter="active = index" @click="active = index">
        <rect :x="x(index)" :y="y(item[metric])" :width="barWidth" :height="height(item[metric])" rx="5" :class="['chart-bar', { selected: active === index, teal: metric === 'works' }]" />
        <text :x="x(index) + barWidth/2" y="215" text-anchor="middle" class="chart-axis">{{ shortMonth(item.month) }}</text>
        <title>{{ month(item.month) }}: {{ formatted(item[metric]) }}</title>
      </g>
    </svg>
    <div class="chart-detail" aria-live="polite"><span>{{ items[active] ? month(items[active].month) : 'Нет данных' }}</span><strong>{{ items[active] ? formatted(items[active][metric]) : '—' }}</strong></div>
    <details class="chart-data"><summary>Посмотреть данные таблицей</summary><table class="payment-history"><thead><tr><th>Месяц</th><th>{{ label }}</th></tr></thead><tbody><tr v-for="item in items" :key="item.month"><td>{{ month(item.month) }}</td><td>{{ formatted(item[metric]) }}</td></tr></tbody></table></details>
  </div>
</template>
<script>
import { money } from '@/utils/format'
export default {
  props: { items: { type: Array, default: () => [] }, metric: String, label: String },
  data: () => ({ active: 0 }),
  computed: {
    maximum() { const max = Math.max(1, ...this.items.map(item => Number(item[this.metric]))); return this.metric === 'works' ? Math.ceil(max / 3) * 3 : max },
    minimum() { return Math.min(0, ...this.items.map(item => Number(item[this.metric]))) },
    barWidth() { return Math.min(48, 578 / Math.max(1, this.items.length) * .55) }
  },
  watch: { items() { this.active = Math.max(0, this.items.length - 1) } },
  mounted() { this.active = Math.max(0, this.items.length - 1) },
  methods: {
    compact(value) { return new Intl.NumberFormat('ru-RU', { notation: 'compact', maximumFractionDigits: 1 }).format(value) },
    formatted(value) { return this.metric === 'payments' ? money(value) : `${value} работ` },
    month(value) { return new Date(value + '-01T12:00:00').toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' }) },
    shortMonth(value) { return new Date(value + '-01T12:00:00').toLocaleDateString('ru-RU', { month: 'short' }) },
    x(index) { return 64 + (index + .5) * (578 / Math.max(1, this.items.length)) - this.barWidth/2 },
    position(value) { return 20 + (this.maximum - Number(value)) / (this.maximum - this.minimum) * 165 },
    height(value) { return Math.abs(this.position(value) - this.position(0)) },
    y(value) { return Math.min(this.position(value), this.position(0)) }
  }
}
</script>
